import { Modal } from 'antd';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { CrossSvg } from '../../../assets/icons';
import theme from '../../../assets/theme';
import { AiAssessedScore } from '../../../frontendServices/gameAPI';
import { LoadingDots } from '../../_atoms/DismissableQuestionList/DismissableQuestionList';
import { MarkdownSlateViewer } from '../../_organisms/DesignerTabPane/AgentTab/MarkdownSlateViewer/MarkdownSlateViewer';
import LiveGameImage from '../LiveGameImage';
const ResponseHighlighterModal = ({
  visible,
  onDone,
  response,
  aiAssessedScore,
  isLoadingScores,
  isDrawing,
  tenantId,
  isAuthenticated,
}: {
  response?: string;
  visible: boolean;
  isDrawing?: boolean;
  onDone: () => void;
  aiAssessedScore?: AiAssessedScore;
  isLoadingScores?: boolean;
  tenantId?: string;
  isAuthenticated?: boolean;
}) => {
  const [responseLength, setResponseLength] = useState<number>();
  useEffect(() => {
    if (response) {
      setResponseLength(response.length);
    }
  }, [response]);

  return (
    <ModalWrapper
      visible={visible}
      onCancel={onDone}
      onOk={onDone}
      footer={null}
      bodyStyle={{ padding: 0 }}
      closable={false}
      centered
      width={
        !aiAssessedScore && responseLength && responseLength < 150 ? undefined : '95vw'
      }
    >
      <BodyContainer>
        <CrossIconWrapper onClick={() => onDone()}>
          <CrossSvg />
        </CrossIconWrapper>
        {aiAssessedScore?.feedback ? (
          <StyledResponseAndFeedback>
            {isDrawing && response && tenantId && (
              <ResponseContainer>
                <LiveGameImage
                  tenantId={tenantId}
                  modifiedAt={1}
                  imageId={response}
                  style={{ width: '100%', background: 'white' }}
                  objectFit="contain"
                  boxShadow="none"
                  fluid
                  isAuthenticated={!!isAuthenticated}
                />
              </ResponseContainer>
            )}
            {!isDrawing && <ResponseContainer>{response}</ResponseContainer>}
            <FeedbackContainer style={{ fontSize: 28 }}>
              <MarkdownSlateViewer content={aiAssessedScore.feedback} fontSize={28} />
            </FeedbackContainer>
          </StyledResponseAndFeedback>
        ) : isLoadingScores ? (
          <StyledResponseAndFeedback>
            {isDrawing && response && tenantId && (
              <ResponseContainer>
                <LiveGameImage
                  tenantId={tenantId}
                  modifiedAt={1}
                  imageId={response}
                  style={{ width: '100%', background: 'white' }}
                  objectFit="contain"
                  boxShadow="none"
                  fluid
                  isAuthenticated={!!isAuthenticated}
                />
              </ResponseContainer>
            )}
            {!isDrawing && <ResponseContainer>{response}</ResponseContainer>}
            <FeedbackContainer>
              Loading feedback <LoadingDots>...</LoadingDots>
            </FeedbackContainer>
          </StyledResponseAndFeedback>
        ) : (
          <StyledResponse>{response}</StyledResponse>
        )}
      </BodyContainer>
    </ModalWrapper>
  );
};

export default ResponseHighlighterModal;

const BodyContainer = styled.div`
  position: relative;
  padding: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 5px solid ${theme.colors.green};
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
`;

const StyledResponse = styled.span`
  font-weight: bold;
  margin-bottom: 0px;
  padding: 0px 15px;
  width: 100%;
  font-size: 40px;
  white-space: pre-wrap;
  @media (max-width: 992px) {
    font-size: 22px;
  }
`;
const StyledResponseAndFeedback = styled.div`
  position: relative;
  width: 100%;
  padding: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  gap: 20px;
  justify-content: center;
`;

const ResponseContainer = styled.span`
  font-weight: bold;
  margin-bottom: 0px;
  padding: 0px 15px;
  font-size: 40px;
  width: 50%;
  white-space: pre-wrap;
  position: relative;
  border: 2px solid ${theme.colors.green};
  @media (max-width: 992px) {
    font-size: 22px;
  }
  border-radius: 10px;
  padding: 10px;
`;

const FeedbackContainer = styled.span`
  font-weight: bold;
  margin-bottom: 0px;
  padding: 0px 15px;
  font-size: 40px;
  width: 50%;
  white-space: pre-wrap;
  @media (max-width: 992px) {
    font-size: 22px;
  }
  @media (max-width: 992px) {
    font-size: 22px;
  }
`;

const ModalWrapper = styled(Modal)`
  .ant-modal-content {
    border-radius: 10px;
    box-shadow: none;
    max-width: 1200px;
    margin: auto;
  }

  .ant-modal-body {
    box-shadow: none;
  }
`;

const CrossIconWrapper = styled.div`
  color: ${theme.colors.black};
  transition: all 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    height: 20px;
    width: 20px;
  }
  cursor: pointer;
  border-radius: 50px;
  padding: 5px;
  &:hover {
    background: rgba(0, 0, 0, 0.3);
  }
  top: 10px;
  right: 10px;
  position: absolute;
`;
